var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHowitworks3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1037_1389)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 32.5,
    fill: "#545454"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 34.5,
    r: 32,
    stroke: "#F58634"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1037_1389",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 16,
    width: 38,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 38,
    height: 38,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1037_1389)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9167 22.3332V31.8728V31.8332V47.6665V22.3332ZM27.0833 38.1665H32.625C32.8625 37.5596 33.1528 36.9922 33.4958 36.4644C33.8389 35.9366 34.2347 35.4484 34.6833 34.9998H27.0833V38.1665ZM27.0833 44.4998H32.1104C31.9785 43.9721 31.8927 43.4443 31.8531 42.9165C31.8135 42.3887 31.8201 41.8609 31.8729 41.3332H27.0833V44.4998ZM23.9167 50.8332C23.0458 50.8332 22.3003 50.5231 21.6802 49.903C21.0601 49.2828 20.75 48.5373 20.75 47.6665V22.3332C20.75 21.4623 21.0601 20.7169 21.6802 20.0967C22.3003 19.4766 23.0458 19.1665 23.9167 19.1665H36.5833L46.0833 28.6665V32.6248C45.5819 32.4137 45.0674 32.2488 44.5396 32.13C44.0118 32.0113 43.4708 31.9255 42.9167 31.8728V30.2498H35V22.3332H23.9167V47.6665H33.4563C33.8785 48.2998 34.3535 48.887 34.8812 49.428C35.409 49.9689 35.9896 50.4373 36.6229 50.8332H23.9167ZM42.125 46.0832C43.2333 46.0832 44.1701 45.7005 44.9354 44.9353C45.7007 44.17 46.0833 43.2332 46.0833 42.1248C46.0833 41.0165 45.7007 40.0797 44.9354 39.3144C44.1701 38.5491 43.2333 38.1665 42.125 38.1665C41.0167 38.1665 40.0799 38.5491 39.3146 39.3144C38.5493 40.0797 38.1667 41.0165 38.1667 42.1248C38.1667 43.2332 38.5493 44.17 39.3146 44.9353C40.0799 45.7005 41.0167 46.0832 42.125 46.0832ZM50.2 52.4165L45.925 48.1415C45.3708 48.511 44.7705 48.788 44.124 48.9728C43.4774 49.1575 42.8111 49.2498 42.125 49.2498C40.1458 49.2498 38.4635 48.5571 37.0781 47.1717C35.6927 45.7863 35 44.104 35 42.1248C35 40.1457 35.6927 38.4634 37.0781 37.078C38.4635 35.6925 40.1458 34.9998 42.125 34.9998C44.1042 34.9998 45.7865 35.6925 47.1719 37.078C48.5573 38.4634 49.25 40.1457 49.25 42.1248C49.25 42.8109 49.1576 43.4773 48.9729 44.1238C48.7882 44.7703 48.5111 45.3707 48.1417 45.9248L52.4167 50.1998L50.2 52.4165Z",
    fill: "#F58634"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1037_1389",
    x: 0,
    y: 0,
    width: 69,
    height: 69,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1037_1389"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1037_1389",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowitworks3);
export default __webpack_public_path__ + "static/media/howitworks3.de493196e188faded4cf0620bcf9be5b.svg";
export { ForwardRef as ReactComponent };